import { render, staticRenderFns } from "./VToc.vue?vue&type=template&id=7ab95bd0&"
import script from "./VToc.vue?vue&type=script&lang=js&"
export * from "./VToc.vue?vue&type=script&lang=js&"
import style0 from "./VToc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports